/**
 * 定制蓝主题 — 颜色与设计令牌
 * 参考 收银台/支付演示.html 与设计稿
 */
export default {
  // 主色（蓝）
  primary: '#2563EB',
  primaryLight: '#3B82F6',
  primaryBright: '#2E86FF',
  primaryDeep: '#1E3A8A',
  primaryNavy: '#001D4C',
  primaryNavyDark: '#0F172A',

  // 文字蓝
  textBlue: '#93C5FD',
  textBlueLight: '#BFDBFE',
  textBlueMuted: 'rgba(191, 219, 254, 0.7)',

  // 按钮
  btnText: '#FFFFFF',
  btnTextAlt: '#001D4C',
  btnGradientStart: '#2563EB',
  btnGradientEnd: '#1E3A8A',
  btnAccentText: '#000000',

  // 复制按钮（黄色强调）
  accentYellow: '#FACC15',
  accentYellowDark: '#EAB308',

  // 边框
  borderGold: '#3B82F6',
  borderAccent: '#2563EB',
  borderGray: '#CBD5E1',
  borderLight: '#E2E8F0',
  borderLighter: '#F1F5F9',
  borderInput: '#2563EB',

  // 文字
  textPrimary: '#1E293B',
  textSecondary: '#475569',
  textMuted: '#94A3B8',
  textDisabled: '#94A3B8',
  textBrownDark: '#1E293B',
  textBrown: '#64748B',
  textBrownLight: '#475569',
  textBrownMuted: '#94A3B8',
  textTitle: '#F8FAFC',
  textPlaceholder: '#CBD5E1',
  textGray: '#64748B',
  textDark: '#0F172A',

  // 状态色
  success: '#4ADE80',
  danger: '#F87171',
  dangerBg: '#FEF2F2',
  dangerBorder: '#FEE2E2',
  tipsRed: '#EF4444',
  amountRed: '#F87171',
  errorRed: '#EF4444',

  // 背景
  bgPage: '#001D4C',
  bgPageNavy: '#001D4C',
  bgCard: '#FFFFFF',
  bgSecondary: '#F2F2F2',
  bgInput: '#FFFFFF',
  bgStripe: '#F1F1F1',
  bgOverlay: 'rgba(255, 255, 255, 0.08)',
  bgBadge: 'rgba(255, 255, 255, 0.2)',
  bgGlass: 'rgba(255, 255, 255, 0.05)',

  // 头部区域
  headerText: '#FFFFFF',
  headerSubText: '#BFDBFE',
  headerMutedText: '#93C5FD',

  // 其他
  white: '#FFFFFF',
  disabled: '#94A3B8',
  smsBtn: '#2563EB',
  pendingDesc: '#93C5FD',
  copyBtn: '#64748B',
  tipsColor: '#F87171',
};
